import CharacterToken from "../classes/CharacterToken.js";
import TokenStore from "../classes/TokenStore.js";
import {
    gameObserver
} from "../constants/observers.js";
import {
    once
} from "../utils/promises.js";

Promise.all([
    once(gameObserver, "characters-loaded", "characters"),
    once(gameObserver, "jinxes-loaded", "jinxes"),
    once(gameObserver, "scripts-loaded", "scripts"),
]).then(([ characters, jinxes, scripts ]) => {

    TokenStore.create({
        characters: [
            // Create an empty character which we can use as a token placeholder.
            {
                id: TokenStore.EMPTY,
                image: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
                ability: I18N.emptyCharacterAbility,
                [CharacterToken.empty]: true,
            },
            ...characters
        ],
        reminders: [
            {
                id: TokenStore.EMPTY,
                name: "",
                text: I18N.goodTeam,
                image: "/build/img/roles/generic/good.webp",
                isGlobal: true
            },
            {
                id: TokenStore.EMPTY,
                name: "",
                text: I18N.evilTeam,
                image: "/build/img/roles/generic/evil.webp",
                isGlobal: true
            },
            {
                id: "executed",
                name: "",
                text: I18N.executedReminder,
                image: "/build/img/roles/generic/demon.webp",
                isGlobal: true
            }
        ],
        jinxes,
        scripts,
    });

});

// Add a delay to all event listeners to be registered before being triggered.
Promise.resolve().then(() => {

    if (!window.PG) {
        throw new ReferenceError("Unable to find the PG object");
    }

    const { roles, jinxes, game, scripts } = window.PG;

    gameObserver.trigger("characters-loaded", { characters: roles });
    gameObserver.trigger("jinxes-loaded", { jinxes });
    gameObserver.trigger("team-breakdown-loaded", { breakdown: game });
    gameObserver.trigger("scripts-loaded", { scripts });
});
